import CommonRadioMulSelect from '../CommonRadioMulSelect';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EAbandonedCheckout {
  HAVE = 'HAVE',
  NOT_HAVE = 'NOT_HAVE',
}
const AbandonCheckout = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, noStyle, disabled } = props;
  return (
    <CommonRadioMulSelect
      disabled={disabled}
      triggerName={[]}
      radioOptions={[
        {
          value: EAbandonedCheckout.HAVE,
          label: getI18n('general.advancedFilters.abandonCheckout.have'),
        },
        {
          value: EAbandonedCheckout.NOT_HAVE,
          label: getI18n('general.advancedFilters.abandonCheckout.notHave'),
        },
      ]}
      radioName={radioName}
      noStyle={noStyle}
    />
  );
};
export default AbandonCheckout;
